import { Asset } from "@/components/ui/Asset";
import { Container } from "@/components/ui/Container";
import { Typography } from "@/components/ui/Typography";
import type { AssetStoryblok } from "@/generated/sb/sb-types";

export interface FullWidthMediaProps {
	asset?: AssetStoryblok;
	label?: string;
}

export const FullWidthMedia = ({ asset, label }: FullWidthMediaProps) => {
	return (
		<div className="relative">
			<div className="aspect-3/4 md:aspect-3/2 lg:aspect-21/9">
				{asset && <Asset asset={asset} sizes="100vw" className="object-cover" />}
			</div>
			{label && (
				<div className="pointer-events-none absolute inset-x-0 bottom-0 py-grid-component-spacing-md">
					<Container>
						<div className="pointer-events-auto inline-flex items-center rounded-[2px] bg-fade-3 px-2 py-1 backdrop-blur-[2.5px]">
							<Typography variant="body-xs-reg" className="text-text-light-text-1">
								{label}
							</Typography>
						</div>
					</Container>
				</div>
			)}
		</div>
	);
};
